"use client"

import { useState } from "react"
import Link from "next/link"

import { useLocale } from "@/lib/locale-context"
import { siteConfig } from "@/lib/site-config"
import { Reveal } from "@/components/reveal"

/** Reversed out of black, closing the page the way it opened. */
export function SectionContact() {
  const { t } = useLocale()
  const [copied, setCopied] = useState(false)

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(t.contact.email)
      setCopied(true)
      setTimeout(() => setCopied(false), 2200)
    } catch {
      /* clipboard can be blocked; the mailto link still works */
    }
  }

  const links = [
    { label: "LinkedIn", href: siteConfig.social.linkedin },
    { label: "GitHub", href: siteConfig.social.github },
    { label: "Docker Hub", href: siteConfig.social.docker },
  ]

  return (
    <section
      id="contact"
      className="scroll-mt-16 bg-foreground text-background"
      aria-labelledby="contact-heading"
    >
      <div className="shell py-12 md:py-20">
        <Reveal className="grid12">
          <span
            className="reveal-rule col-span-12 mb-5 block h-[3px] bg-accent"
            aria-hidden="true"
          />
          <div className="col-span-12 md:col-span-7">
            <p className="reveal t-small tabular-nums text-accent">06</p>
            <h2 id="contact-heading" className="reveal-clip t-lg mt-2">
              {t.contact.title}
            </h2>
            <p
              className="reveal t-body mt-4 max-w-[52ch] text-background/80"
              style={{ ["--d" as string]: "90ms" }}
            >
              {t.contact.description}
            </p>
            <a
              href={`mailto:${t.contact.email}`}
              className="reveal t-xl mt-8 block transition-colors hover:text-accent"
              style={{ ["--d" as string]: "140ms" }}
            >
              {t.contact.email}
            </a>
            <div className="reveal mt-8 flex flex-wrap gap-3" style={{ ["--d" as string]: "180ms" }}>
              <a
                href={`mailto:${t.contact.email}`}
                className="btn t-small bg-background px-6 py-3 font-medium uppercase tracking-[0.06em] text-foreground transition-colors hover:text-background"
              >
                {t.contact.cta}
              </a>
              <button
                type="button"
                onClick={copyEmail}
                className="btn t-small border border-background/60 px-6 py-3 font-medium uppercase tracking-[0.06em] text-background transition-colors hover:border-accent"
              >
                {copied ? "Copied" : "Copy address"}
              </button>
              <Link
                href="/cv"
                className="btn t-small border border-background/60 px-6 py-3 font-medium uppercase tracking-[0.06em] text-background transition-colors hover:border-accent"
              >
                {t.hero.ctaCv}
              </Link>
            </div>
          </div>

          <ul
            className="reveal col-span-12 mt-10 md:col-span-4 md:col-start-9 md:mt-0"
            style={{ ["--d" as string]: "200ms" }}
          >
            {links.map((item) => (
              <li key={item.label} className="border-t border-background/25">
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="t-small flex justify-between gap-4 py-2.5 transition-colors hover:text-accent"
                >
                  {item.label}
                  <span className="text-background/60">
                    {new URL(item.href).hostname.replace("www.", "")}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  )
}
